import * as PIXI from "pixi.js";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { SlingoLang } from "../lang/SlingoLang";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractTotalWinCounterProperties.ts
 */
export class AbstractTotalWinCounterProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.titleFieldProperties.equals(other.titleFieldProperties) &&
            this.valueFieldProperties.equals(other.valueFieldProperties);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.TOTAL_WIN_COUNTER, SlingoStyle.MODULE);
        this.titleFieldProperties = new TextFieldProperties(FontStyle.TOTAL_WIN_COUNTER, new PIXI.Point(167, 12), SlingoLang.TOTAL_WIN_TITLE, ControlConstants.CENTER, ControlConstants.CENTER);
        this.titleFieldProperties.size = new PIXI.Point(249, 85);
        this.valueFieldProperties = new TextFieldProperties(FontStyle.TOTAL_WIN_COUNTER, new PIXI.Point(167, 12), null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.valueFieldProperties.size = new PIXI.Point(249, 85);
    }
}
//# sourceMappingURL=AbstractTotalWinCounterProperties.js.map